<script lang="ts">
  export let handler: () => void
</script>

<button class="crtw-bg-white crtw-flex" on:click={handler}>
  <slot />
</button>
